package org.dronda.app.web

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet
import kotlinx.browser.document
import org.dronda.app.web.ui.DefaultStyles
import org.dronda.app.web.ui.MainScreen
import org.dronda.app.web.ui.components.ComponentStyles
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.dom.stringPresentation
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLHeadElement
import org.w3c.dom.HTMLStyleElement
import org.w3c.dom.asList
import org.w3c.dom.css.CSSStyleSheet

fun main() {
    val mainModule = MainModule()
    renderComposable(rootElementId = "root") {
        HeaderStyle(KobwebComposeStyleSheet)
        HeaderStyle(DefaultStyles)
        HeaderStyle(LoaderStyles)
        HeaderStyle(ComponentStyles)

        val mainScreenViewModel = rememberViewModel(mainModule.mainScreenViewModelFactory)
        MainScreen(mainScreenViewModel, mainModule)
    }

}

@Composable
fun HeaderStyle(styleSheet: StyleSheet) {
    DisposableEffect(styleSheet) {
        val head: HTMLHeadElement = document.getElementsByTagName("head").asList().first() as HTMLHeadElement
        val styleTag = document.createElement("style") as HTMLStyleElement
        head.appendChild(styleTag)

        (styleTag.sheet!! as CSSStyleSheet).apply {
            styleSheet.cssRules.forEach { rule ->
                insertRule(rule.stringPresentation(), this.cssRules.length)
            }
        }

        onDispose {
            head.removeChild(styleTag)
        }
    }
}